import { Component } from '@angular/core';

/**
 * Pricing & limits guide (/docs/pricing-limits) the flat 1-credit cost,
 * prepaid wallet model, rate limit, and the two "not charged"/"may go
 * negative" edge cases. Split out of the old single /docs mega-page (see
 * docs/overview/docs.ts) so it has its own route.
 */
@Component({
  selector: 'app-docs-pricing-limits',
  standalone: false,
  templateUrl: './docs-pricing-limits.html',
})
export class DocsPricingLimits {}
